import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export function CalendarCellDate({ date, event }) {
	const { t } = useTranslation()

	return (
		<div className="mt-1 mr-1 fw-bold text-decoration-none">
			{event && t(event.descKey)} {DateTime.fromJSDate(date.date).toFormat('d.M.')}
		</div>
	)
}

export const PersonalCalendarWrapper = styled.div.attrs({
	className: 'personal-calendar',
})`
  .fc {
    background-color: transparent;

    &.fc-media-screen {
      height: 100%;
    }

    .fc-scrollgrid-liquid {
      border-top: 0;
      border-left: 0;
    }

    .fc-col-header-cell-cushion {
      text-decoration: none;
    }

    th.fc-col-header-cell.fc-day.fc-current {
      position: relative;
      /* Override table border collapse */

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        width: 100%;
        border-top: 2px solid var(--heeros-purple);
      }
    }

    td.fc-day-sat,
    td.fc-day-sun {
      background-color: #f0f3f7;
    }

    td.fc-daygrid-day.fc-day-today {
      position: relative;
      background-color: var(--heeros-purple-100);

      /* Override table border collapse */

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        width: 100%;
        border-top: 2px solid var(--heeros-purple);
      }
    }

    .fc-daygrid-day-number {
      text-decoration: none;
      color: var(--heeros-primary-gray-600);
      z-index: 10;
    }

    .fc-daygrid-week-number {
      color: var(--heeros-blue-500);
      background-color: transparent;
      text-decoration: none;
      z-index: 10;
    }

    .fc-daygrid-day-top {
      position: relative;
      z-index: 10;
    }

    .fc-button-group {
      border: 1px solid rgba(223, 223, 223, 1);
      border-radius: 4px;
    }

    .fc-button-group > .fc-button {
      background-color: transparent;
      border: 0;
    }

    .fc-col-header-cell-cushion {
      color: var(--heeros-blue-500);
    }

    .fc-h-event {
      background-color: transparent;
      border: 0;
    }

    .fc-daygrid-month-start {
      font-size: 13px;
    }

    td.fc-daygrid-holiday {
      background-color: var(--heeros-card-stroke-background);
    }

    .fc-daygrid-day-frame {
      position: relative;
      /* z-index: 1; !!this breaks events spanning multiple days!! */
    }

    td.fc-daygrid-day.fc-daygrid-holiday .fc-daygrid-day-frame:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.3);

      pointer-events: none;
      z-index: 5;
    }

    td.fc-day-sat .fc-daygrid-day-frame:after,
    td.fc-day-sun .fc-daygrid-day-frame:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.2);

      pointer-events: none;
      z-index: 5;
    }

    td.specialdate-with-event .fc-daygrid-day-frame:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: repeating-linear-gradient(
        45deg,
      rgba(0, 0, 0, 0.15),
      rgba(0, 0, 0, 0.15) 4px,
      transparent 4px,
      transparent 12px
      );
      pointer-events: none;
      z-index: 5;
    }
  }
`
